import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import { PERMISSION } from 'src/features/auth';
import { PATH } from 'src/features/navigation/utils/constants';
import { paymentsMessages } from 'src/features/payment/utils/messages';
import useHasPermissions from 'src/hooks/useHasPermissions';
import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';
import { useTitleStore } from 'src/stores/useTitleStore';

export default function PaymentLayout() {
    const { formatMessage } = useIntl();

    const accessPayments = useHasPermissions([PERMISSION.ACCESS_PAYMENTS]);
    const accessPayStations = useHasPermissions([PERMISSION.ACCESS_PAY_STATIONS]);
    const accessPayStationsOperations = useHasPermissions([PERMISSION.ACCESS_PAY_STATION_OPERATIONS]);
    const accessPayStationsEvents = useHasPermissions([PERMISSION.ACCESS_PAY_STATION_EVENTS]);

    const { removeTitle, setTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(paymentsMessages.payments));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <MainLayout>
            <TabRow>
                {accessPayments && (
                    <Tab end to={`/${PATH.PAYMENTS}/payments`}>
                        <FormattedMessage {...paymentsMessages.payments} />
                    </Tab>
                )}
                {accessPayStations && (
                    <Tab end to={`/${PATH.PAYMENTS}/pay-station`}>
                        <FormattedMessage {...paymentsMessages.payStations} />
                    </Tab>
                )}
                {accessPayStationsOperations && (
                    <Tab end to={`/${PATH.PAYMENTS}/operation`}>
                        <FormattedMessage {...paymentsMessages.operations} />
                    </Tab>
                )}
                {accessPayStationsEvents && (
                    <Tab end to={`/${PATH.PAYMENTS}/event`}>
                        <FormattedMessage {...paymentsMessages.eventLogs} />
                    </Tab>
                )}
            </TabRow>
            <Outlet />
        </MainLayout>
    );
}
